import {DeviceSize, useDeviceSize} from './../theme/helpers';
import {blockCard} from './../../redux/actions/profile/index';
import {useDialog} from '../components/modal/dialog';

import {useAppDispatch} from '../../redux';

export const useBlockCardDialog = (): (() => Promise<void>) => {
  const dialog = useDialog();
  const deviceSize = useDeviceSize();
  const dispatch = useAppDispatch();
  return async () => {
    dialog.showDialog({
      message: 'Вы действительно хотите заблокировать карту?',
      actions: [
        {
          title: 'Да',
          type: 'primary',
          closeModal: true,
          onPress: () => {
            dispatch(blockCard());
          },
        },
        {
          title: 'Отмена',
          type: 'transparent',
          closeModal: true,
        },
      ],
      contentStyle: {
        paddingTop: 30,
      },
      messageStyle:
        deviceSize === DeviceSize.desktop ? {width: 340, maxWidth: 340, marginBottom: 37} : {marginBottom: 30},
    });
  };
};
